"use strict";

exports.__esModule = true; // NAVIGATION

var keyMap = {
  '37': 'ArrowLeft',
  '38': 'ArrowUp',
  '39': 'ArrowRight',
  '40': 'ArrowDown',
  '13': 'MediaPlayPause',
  '461': 'Backspace',
  '8': 'Backspace',
  '403': 'Red',
  '404': 'Green',
  '405': 'Yellow',
  '406': 'Blue',
  '19': 'MediaPause',
  '415': 'MediaPlay',
  '413': 'MediaStop',
  '412': 'MediaRewind',
  '417': 'MediaFastForward',
  '424': 'MediaPrev',
  '425': 'MediaNext',
  '463': 'MediaPlayPause',
  '32': ' '
};

exports.getKeyFromKeyboardEvent = function (e) {
  if (typeof e.key !== 'undefined') {
    return e.key;
  }

  return keyMap[String(e.keyCode)] || '';
};